import React from 'react';

/**
 * Notifications settings page for agents.
 */
export const SettingsNotifications = () => {
  return (
    <div>
      <h2>Notifications Settings</h2>
    </div>
  );
};
